<div [class]="'container-toast ' + (activo ? 'toast-activo' : 'toast-inactivo')">
  <img
    class="imagen-toast"
    src="https://martielbeatty.com/wp-content/uploads/2018/03/green-tick-png-green-tick-icon-image-14141-1000-300x300.png"
    alt="Icono Exito">
  <span>{{mensaje}}</span>
  <button (click)="cerrarToast()">Cerrar</button>
</div>
